export function bing(): any {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const client = window.uetq || (window.uetq = []);
  return client;
}

export function convert(): void {
  return bing().push('event', {
    ec: 'conversion',
    ea: 'submit_success',
    el: 'lead',
  });
}

export default {
  convert,
};
